import * as Yup from 'yup';
// for the UW form, we use validation to determine if a user has submitted a wrong answer (an answer that goes against underwriting rules).
// ex. user submits Yes for noAsbestosCheck question, that will make the offer ineligible for home.
// the validation will run and return an error object with the node, which will be used in cannot-offer-modal.js to determine eligibility
// at that modal, the user is given the option to drop home/auto, setting ineligibleForHomeDueToUWSelfReport/ineligibleForAutoDueToUWSelfReport to true
// and skip validation to submit and recalc so that the backend UW rules can drop the ineligible policy type

const UWPropertyValidationSchema = () =>
  Yup.object().shape({
    signedPropertyUWAttestation: Yup.boolean().oneOf([true], 'Agent must check attestation checkbox').required()
  });

const noAsbestosCheckSchema = Yup.object().shape({
  home: Yup.object().shape({
    noAsbestosCheck: Yup.string()
      .test('noAsbestosCheck', '', (value) => value !== 'Yes' && value !== '' && value !== null && value !== undefined)
      .required('This field is required')
  })
});

const homeWiringCheckSchema = Yup.object().shape({
  home: Yup.object().shape({
    homeWiringCheck: Yup.string()
      .test('homeWiringCheck', '', (value) => value !== 'No' && value !== '' && value !== null && value !== undefined)
      .required('This field is required')
  })
});

const homePlumbingCheckSchema = Yup.object().shape({
  home: Yup.object().shape({
    homePlumbingCheck: Yup.string()
      .test('homePlumbingCheck', '', (value) => value !== 'No' && value !== '' && value !== null && value !== undefined)
      .required('This field is required')
  })
});

const noOpenFoundationCheckSchema = Yup.object().shape({
  home: Yup.object().shape({
    noOpenFoundationCheck: Yup.string()
      .test(
        'noOpenFoundationCheck',
        '',
        (value) => value !== 'Yes' && value !== '' && value !== null && value !== undefined
      )
      .required('This field is required')
  })
});

export const buildSchema = (conditions) => {
  const { noAsbestosCheck, homeWiringCheck, homePlumbingCheck, noOpenFoundationCheck } = conditions;

  let schema = UWPropertyValidationSchema();

  if (noAsbestosCheck) {
    schema = schema.concat(noAsbestosCheckSchema);
  }
  if (homeWiringCheck) {
    schema = schema.concat(homeWiringCheckSchema);
  }
  if (homePlumbingCheck) {
    schema = schema.concat(homePlumbingCheckSchema);
  }
  if (noOpenFoundationCheck) {
    schema = schema.concat(noOpenFoundationCheckSchema);
  }
  return schema;
};
